/*eslint-disable*/
import { useGet } from "./useRequest";
export const loadJobTypes = () => {
  const path = "/adminproxy/jobTypes";
  const response = useGet(path);
  return response;
};

export const loadOccupations = () => {
  const path = "/adminproxy/occupations?levels=3&levels=4";
  const response = useGet(path);
  return response;
};

export const loadJobStatuses = () => {
  const path = "/adminproxy/jobStatus";
  const response = useGet(path);
  return response;
};

export const loadConfidentialQuestionnaire = (jobid) => {
  const path = `/quickapplications/jobs/${jobid}/confidentialquestionnaire`;
  const response = useGet(path);
  return response;
};

export const loadConfidentialQuestionnaireAcceptanceStage = (jobid) => {
  const path = `/jobs/${jobid}/confidentialInformationAcceptanceStage`;
  const response = useGet(path);
  return response;
};

export const loadOrganisationQuestionnaire = (jobid) => {
  const path = `/jobs/${jobid}/organisationquestionnaire`;
  const response = useGet(path);
  return response;
};

export const loadScreeningQuestionnaire = (jobid) => {
  const path = `/jobs/${jobid}/screeningquestionnaire`;
  const response = useGet(path);
  return response;
};

export const getJobUrlIdentifier = (jobid) => {
  const path = `/jobs/${jobid}/urlidentifier`;
  const response = useGet(path);
  return response;
};

export const loadJob = (jobid) => {
  const path = `/jobs/${jobid}/load`;
  const response = useGet(path);
  return response;
};



